<template>
  <section class="otcDetailOrder-pays clearfix" v-if="isReady">
    <!-- 卖家支付方式 -->
    <div class="otcDetailOrder-pays-title main-cl">
      {{ $t("otcDetailOrder.SellersPaymentMethod") }}
    </div>
    <div class="otcDetailOrder-pays-body">
      <ul class="paysList" v-if="showPay">
        <li class="clearfix" v-for="(item, index) in pays" :key="index">
          <!-- 选择框 仅支付方 在未支付情况下展示 -->
          <div class="paysList-redio" v-if="commonData.side === 'BUY'" @click="payClick(item)">
            <c-redio :value="payObj.payment === item.payment ? true : false" />
          </div>
          <!-- 信息 支付宝/微信 -->
          <div class="paysList-message clearfix" v-if="item.payment === 'otc.payment.alipay' || item.payment === 'otc.payment.wxpay'">
            <div class="paysList-message-type b-1-cl">
              <svg-icon :icon-class="getIconClassName(item.payment)"></svg-icon>
              <span class="name gray-cl">{{ item.name }}</span>
            </div>
            <!-- 姓名 账号 -->
            <div class="paysList-account-info main-cl">
              <span class="paysList-message-text">{{ item.userName }}</span>
              <span class="paysList-message-text">
                {{ item.account }}
              </span>
              <span class="paysList-message-ewm" v-if="commonData.side === 'BUY'">
                <svg-icon class="icon icon-18" icon-class="icon-qrcode"></svg-icon>
                <div class="paysList-message-ewm-mark h-2-bg">
                  <img :src="item.qrcodeImg" />
                </div>
              </span>
            </div>
          </div>
          <!-- 信息 银行卡 -->
          <div class="paysList-message clearfix" v-else-if="item.payment === 'otc.payment.domestic.bank.transfer'">
            <div class="paysList-message-type b-1-cl">
              <svg-icon icon-class="icon-bank"></svg-icon>
              <span class="name gray-cl">{{ item.name }}</span>
            </div>
            <!-- 姓名 卡号 银行 支行 -->
            <div class="paysList-message-bank main-cl">
              <span>{{ item.userName }}</span>
              <span>{{ item.account }}</span>
              <span>{{ item.bankName }}</span>
              <span>{{ item.bankOfDeposit }}</span>
            </div>
          </div>
          <!-- 其他 -->
          <div class="paysList-message clearfix" v-else>
            <div class="paysList-message-type b-1-cl">{{ item.name }}</div>
            <!-- 姓名 账号 -->
            <div>
              <span class="paysList-message-text">{{ item.userName }} {{ item.account }}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="b-1-cl text" v-if="showText.length">{{ showText }}</div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    commonData: { default: () => ({}), type: Object },
    isReady: { default: false, type: Boolean },
    // 买家支付时，选择的支付方式对象
    payObj: { default: () => ({}), type: Object },
  },
  computed: {
    otcPublicInfo() {
      return this.$store.state.baseData.otcPublicInfo;
    },
    pays() {
      const arr = [];
      if (this.isReady && (this.otcPublicInfo && this.otcPublicInfo.payments) && (this.commonData && this.commonData.payment)) {
        this.commonData.payment.forEach((v) => {
          if (v) {
            const obj = v;
            this.otcPublicInfo.payments.forEach((cv) => {
              if (v.payment === cv.key) {
                obj.name = cv.title;
              }
            });
            arr.push(obj);
          }
        });
      }
      return arr;
    },
    status() {
      if (this.commonData.status) {
        return this.commonData.status.toString();
      }
      return '0';
    },
    showText() {
      let str = '';
      if (this.isReady) {
        const { side } = this.commonData;
        // 您已付款，无法查看对方支付信息
        if (side === 'BUY' && this.status === '2') {
          str = this.$t('otcDetailOrder.paysBuy2');
          // 您已付款，无法查看对方支付信息
        } else if (side === 'BUY' && this.status === '3') {
          str = this.$t('otcDetailOrder.paysBuy3');
          // 订单已完成，无法查看支付信息
        } else if (side === 'SELL' && this.status === '3') {
          str = this.$t('otcDetailOrder.paysSell3');
          // 订单已关闭，无法查看支付信息
        } else if (this.status === '4' || this.status === '9') {
          str = this.$t('otcDetailOrder.pays4');
          // 订单申诉中，无法查看支付信息
        } else if (this.status === '5') {
          str = this.$t('otcDetailOrder.pays5');
          // 订单异常，无法查看支付信息
        } else if (this.status === '7') {
          str = this.$t('otcDetailOrder.pays7');
          // 您已付款，无法查看对方支付信息
        } else if (side === 'BUY' && this.status === '8') {
          str = this.$t('otcDetailOrder.paysBuy8');
          // 订单已完成，无法查看支付信息
        } else if (side === 'SELL' && this.status === '8') {
          str = this.$t('otcDetailOrder.paysSell8');
        }
      }
      return str;
    },
    showPay() {
      let flag = false;
      if (this.isReady) {
        const { side } = this.commonData;
        if (this.status === '1') {
          flag = true;
        } else if (side === 'SELL' && this.status === '2') {
          flag = true;
        }
      }
      return flag;
    },
  },
  methods: {
    payClick(v) {
      this.$emit('setPayObj', v);
    },
    getIconClassName(key) {
      const iconMap = {
        'otc.payment.alipay': 'icon-ali',
        'otc.payment.wxpay': 'icon-wechat',
      };
      return iconMap[key];
    },
  },
};
</script>

<style lang="scss" scoped>
.otcDetailOrder-pays {
  min-height: 200px;

  .otcDetailOrder-pays-title {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 26px;
  }

  .otcDetailOrder-pays-body {

  }

  .text {
    font-size: 14px;
  }
  .paysList {
    li {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    .paysList-redio {
      float: left;
      margin-right: 8px;
      transform: translate(0px, 8px);
    }

    .paysList-message {
      float: left;
      font-size: 14px;
    }

    .paysList-message-type {
      margin-bottom: 6px;
      vertical-align: middle;
      display: flex;
      align-items: center;
      gap: 8px;

      svg {
        font-size: 30px;
      }

      .name {
        font-weight: 500;
        font-size: 16px;
      }
    }

    .paysList-account-info {
      display: flex;
      align-items: center;
      gap: 24px;
    }

    .paysList-message-text,
    .paysList-message-bank {
      max-width: 500px;
      display: flex;
      align-items: center;
      gap: 24px;
      word-wrap: break-word;
      line-height: 20px;
    }

    .paysList-message-ewm {
      cursor: pointer;
      vertical-align: middle;
      position: relative;
      &:hover {
        .paysList-message-ewm-mark {
          display: block;
          z-index: 2;
        }
      }
      .paysList-message-ewm-mark {
        position: absolute;
        left: 30px;
        top: 0;
        padding: 5px;
        border-radius: 2px;
        display: none;

        img {
          max-width: 138px;
          max-height: 210px;
          display: block;
        }
      }
    }
  }
}
</style>
